module.exports = __webpack_public_path__ + "img/CMHK_01_zhTc.248a4f34.png";